import Repository from "@/repositories/RepositoryFactory";
import groupRepository from "../../repositories/groups";
import gpsDataRepository from "../../repositories/gpsDataRepository";
import APISTATE from "../../enums/APISTATE";
import Vuex from "vuex";

const SalaryManualInputRepository = Repository.get( "salaryManualInput" );

export default {
    namespaced: true,
    state: {
        csvModalOpen: false,
        discriminator: {},
        discriminatorOptions: [ { key: 'OnAccount', value: 'Aconto' }, { key: 'CommissionSales', value: 'Provisionssalg' }, { key: 'SpecialHolidayAllowance', value: 'Særlig feriegodtgørelse' }  ],
        selectedFile: null
    },
    mutations: {
        setCsvOpenModal: ( state, csvModalOpen ) => {
            state.csvModalOpen = csvModalOpen;
        },
        setDiscriminator: ( state, discriminator ) => {
            state.discriminator = discriminator
        },
        setSelectedFile: ( state, file ) => {
            state.selectedFile = file;
        }
    },
    actions: {
        setModalOpen: ( { commit }, csvModalOpen ) => { commit( "setCsvOpenModal", csvModalOpen ) },
        setDiscriminator: ( { commit }, discriminator ) => { commit( "setDiscriminator", discriminator ) },
        setSelectedFile: ( { commit }, file ) => { commit( "setSelectedFile", file ) },
        uploadFile: async ( { commit, state, dispatch } ) => {
            let data = new FormData();
            // console.log( 'selectedFile', state.selectedFile )
            data.append( 'file', state.selectedFile );
            data.append( 'discriminator', state.discriminator.key )
            // console.log( 'keys', data.keys() )

            await SalaryManualInputRepository.uploadCsv( data );
            commit( "setSelectedFile", null );

            await dispatch( 'salaryReportStore/performLookup', {}, { root: true } );
            commit( "setCsvOpenModal", false );
        }
    },
    getters: {
        isOpen: ( state ) => { return state.csvModalOpen },
        discriminator: ( state ) => { return state.discriminator },
        discriminatorOptions: ( state ) => { return state.discriminatorOptions },
        selectedFile: ( state ) => { return state.selectedFile }
    }
};
